import React, { Component } from 'react'

const colors = ["linear-gradient(to right, #b8cbb8 0%, #b8cbb8 0%, #b465da 0%, #cf6cc9 33%, #ee609c 66%, #ee609c 100%)", "linear-gradient(to top, #37ecba 0%, #72afd3 100%)", "linear-gradient(to top, #d299c2 0%, #fef9d7 100%)"];
function randomColor() {
    const randomNumber = Math.floor(Math.random() * colors.length);

    return colors[randomNumber];
}

export class Updatetodo extends Component {

    inputValueChangeHanlder = (e) => {
        this.props.updateTodoText(e)
    }

    changeValueSubmission = (e) => {
        e.preventDefault();
        if (this.props.todoText == "")
            return this.props.cancelUpdate()

        this.props.updateTodoSubmission();
    }

    cancelUpdateHandler = () => {
        this.props.cancelUpdate()
    }

    render() {
        const currentBody = this.props.currentTodoBody
        return (
            <form onSubmit={this.changeValueSubmission} className="update-todo-form">
                <input placeholder={currentBody} onChange={this.inputValueChangeHanlder} />
                <button type="submit" style={{ background: randomColor() }}>Update</button>
                <button type="button" onClick={this.cancelUpdateHandler} style={{ background: randomColor() }}>Cancel</button>
            </form>
        )
    }
}

export default Updatetodo
